<div class="container">
    <div [innerHTML]="getHighlightedNoteBody() | safeHtml"></div>
</div>